export default function ChevronIcon() {
  return (
    <svg className="day-card-chevron" viewBox="0 0 16 16" fill="none"
      stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true">
      <polyline points="4 6 8 10 12 6" />
    </svg>
  );
}
